import React from "react";
import { LoginContext } from "@context/loginContext";
import Menu from "../Menu";
import logo from "../../../assets/logo.svg";
import logoDirecional from "../../../assets/LogoDirecional.png";
import logoRiva from "../../../assets/Rivalogo.png";
import { useAuth } from "src/routes";
import { useNavigate } from "react-router-dom";
import { capitalize } from "@helpers/format";
import { linkSidebar } from "@helpers/linkSidebar";
import {
  Box,
  Flex,
  Icon,
  Image,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { UsuallyContext } from "@context/usuallyContex";
import { theme } from "src/styles/theme";
import { BiBell, BiUser } from "react-icons/bi";
import { SlOptionsVertical } from "react-icons/sl";
import DrawerNotification from "../DrawerNotification";
import DrawerUser from "../DrawerUser";
import notifyServiceInstance from "@services/Notify/notifyService";
import { OportunityContext } from "@context/oportunityContex";

const MenuSideBar = () => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    pageSidebar,
    setPageSidebar,
    notifications,
    setNotifications,
    isMarkedNotifications,
    setIsMarkedNotifications,
  } = React.useContext(LoginContext);
  const {
    setHashSalesSidebar,
    setHashDetailOportunity,
    setHashOportunity,
    setIsChatOpen,
  } = React.useContext(UsuallyContext);
  const { setAccessCreateOp, setFaseMyOportunity } =
    React.useContext(OportunityContext);
  const isAuthenticated = useAuth();
  const navigate = useNavigate();
  const user: any = localStorage.getItem("@user");
  const email: any = localStorage.getItem("@email");
  const tipoDeUsuario: string | null = localStorage.getItem("@tipoDeUsuario");
  const [openUser, setOpenUser] = React.useState(false);

  const handleOptionClick = React.useCallback(
    (label: string) => {
      setPageSidebar(label);
      localStorage.setItem("@option", label);
      toast.closeAll();
    },
    [setPageSidebar, toast],
  );

  const handleClickImg = React.useCallback(
    (e: any) => {
      e.stopPropagation();
      setPageSidebar("Home");
      navigate("/");
      localStorage.setItem("@option", "Home");
      toast.closeAll();
    },
    [navigate, setPageSidebar, toast],
  );

  const handleNavigateOportunity = React.useCallback(
    (name: string) => {
      if (name?.toLowerCase() === "criar oportunidade") {
        setHashSalesSidebar("Oportunity");
      } else if (name?.toLowerCase() === "minhas oportunidades") {
        setHashSalesSidebar("MyOportunityComponent");
        setHashDetailOportunity("DetailOportunity");
        setFaseMyOportunity([]);
      } else {
        setHashSalesSidebar("");
      }
    },
    [setFaseMyOportunity, setHashDetailOportunity, setHashSalesSidebar],
  );

  const handleMarkDisplayed = React.useCallback(async () => {
    const idsNotificacaoNovaOp = notifications
      .filter((notification) => notification.tipoNotificacao === "NovaOP")
      .map((notification) => notification.id);

    const idsNotificacaoRetornoAC = notifications
      .filter((notification) => notification.tipoNotificacao === "RetornoAC")
      .map((notification) => notification.id);

    const idsNotificacaoRetornoCotacao = notifications
      .filter(
        (notification) => notification.tipoNotificacao === "RetornoCotacao",
      )
      .map((notification) => notification.id);

    const data = {
      idsNotificacaoNovaOp,
      idsNotificacaoRetornoAC,
      idsNotificacaoRetornoCotacao,
    };

    try {
      const response = await notifyServiceInstance.markDisplayed(data);

      if (response?.status >= 400 && response?.status !== 401) {
        console.log("Erro ao marcar notificações como exibidas:", response);
        return;
      }

      if (response?.status === 401) {
        console.log("Usuário não autorizado:", response);
        setIsMarkedNotifications(false);
        return;
      }
    } catch (error) {
      console.error("Erro ao marcar notificações como exibidas:", error);
    }
  }, [notifications, setIsMarkedNotifications]);

  const handleNavigationSales = React.useCallback(() => {
    setHashOportunity("Oportunity");
    setHashSalesSidebar("Oportunity");
    setHashDetailOportunity("DetailOportunity");
    setAccessCreateOp({
      nomeDaConta: "",
      oportunidadeId: "",
      oportunityIdSalesforce: "",
    });
  }, [
    setHashDetailOportunity,
    setHashOportunity,
    setHashSalesSidebar,
    setAccessCreateOp,
  ]);

  const handleNavigationMyOportunity = React.useCallback(() => {
    setHashOportunity("MyOportunityComponent");
    setHashSalesSidebar("MyOportunityComponent");
    setHashDetailOportunity("DetailOportunity");
    setAccessCreateOp({
      nomeDaConta: "",
      oportunidadeId: "",
      oportunityIdSalesforce: "",
    });
  }, [
    setAccessCreateOp,
    setHashDetailOportunity,
    setHashOportunity,
    setHashSalesSidebar,
  ]);

  const handleNavigateMenu = React.useCallback(
    (label: string, to: string) => {
      if (label === "Notificações") {
        onOpen();
        handleMarkDisplayed();
      } else if (label === "Elô") {
        setIsChatOpen(true);
      } else if (label === "Criar oportunidade") {
        handleNavigationSales();
        handleOptionClick(label);
        navigate("/oportunidades");
        handleNavigateOportunity(label);
      } else if (label === "Minhas oportunidades") {
        handleNavigationMyOportunity();
        handleOptionClick(label);
        navigate("/oportunidades/minhas-oportunidades");
        handleNavigateOportunity(label);
      } else {
        handleOptionClick(label);
        navigate(to);
        handleNavigateOportunity(label);
      }
    },
    [
      handleNavigateOportunity,
      handleNavigationMyOportunity,
      handleNavigationSales,
      handleOptionClick,
      navigate,
      onOpen,
      handleMarkDisplayed,
      setIsChatOpen,
    ],
  );

  const truncateName = React.useCallback((name: string, maxLength: number) => {
    if (name?.length > maxLength) {
      return name?.slice(0, maxLength) + "...";
    } else return name;
  }, []);

  React.useLayoutEffect(() => {
    const storedOption: string | null = localStorage.getItem("@option");

    if (storedOption) {
      setPageSidebar(storedOption);
      handleNavigateOportunity(storedOption);
    }
  }, [
    setHashDetailOportunity,
    setHashSalesSidebar,
    setPageSidebar,
    handleNavigateOportunity,
  ]);

  return (
    <>
      <DrawerNotification
        isOpen={isOpen}
        onClose={onClose}
        notifications={notifications}
        setNotifications={setNotifications}
        setIsMarked={setIsMarkedNotifications}
      />

      <DrawerUser isOpen={openUser} onClose={() => setOpenUser(false)} />

      <Flex
        display={isAuthenticated ? "flex" : "none"}
        pos={"fixed"}
        top={0}
        left={0}
        flexDir={"column"}
        w={{ base: 0, lg: "230px" }}
        h={"100%"}
        background={theme.primary700}
        zIndex={999}
        transition={"0.2s"}
      >
        <Box display={{ base: "flex", lg: "none" }}>
          <Menu
            selectedOption={pageSidebar}
            setSelectedOption={setPageSidebar}
          />
        </Box>

        <Flex
          display={{ base: "none", lg: "flex" }}
          flexDir={"column"}
          w={"100%"}
          h={"100%"}
          overflow="hidden"
        >
          {/* Header com Logo e Notificação */}
          <Flex
            p={3}
            justifyContent="space-between"
            alignItems="center"
            minH={{ base: "70px", md: "50px" }}
          >
            {/* Logo */}
            <Box
              bg="whiteAlpha.200"
              display={"flex"}
              w={"fit-content"}
              p={{ base: 2, md: 2 }}
              borderRadius={"8px"}
              cursor="pointer"
              onClick={handleClickImg}
              _hover={{
                bg: "whiteAlpha.300",
                transform: "scale(1.02)",
              }}
              transition="all 0.2s"
            >
              <Image
                src={logo || "/placeholder.svg"}
                alt="Logo"
                w={{ base: "120px", md: "140px" }}
                h="auto"
              />
            </Box>

            {/* Ícone de Notificação */}
            <Box
              position="relative"
              w={"fit-content"}
              h={"fit-content"}
              onClick={() => {
                onOpen();
                handleMarkDisplayed();
              }}
            >
              <Icon
                cursor={"pointer"}
                fontSize="22px"
                color="white"
                as={BiBell}
                _hover={{ animation: "shake 0.5s" }} // Ativa a animação de balanço
              />

              {/* Badge de Notificação */}
              {isMarkedNotifications && (
                <Box
                  position="absolute"
                  top="-2px"
                  right="0px"
                  bg={theme.error}
                  w="10px"
                  h="10px"
                  borderRadius="full"
                  border="2px solid"
                  borderColor={theme.primary700}
                />
              )}
            </Box>

            {/* Keyframes da Animação */}
            <style>
              {`
                @keyframes shake {
                  0% { transform: rotate(0deg); }
                  25% { transform: rotate(-10deg); }
                  50% { transform: rotate(10deg); }
                  75% { transform: rotate(-10deg); }
                  100% { transform: rotate(0deg); }
                }
              `}
            </style>
          </Flex>

          {/* Seção do Usuário */}
          <Flex
            p={2}
            gap={3}
            cursor={"pointer"}
            onClick={() => setOpenUser(true)}
            borderBottom="1px solid"
            borderColor="whiteAlpha.200"
            pb={"20px"}
          >
            {/* Avatar */}
            <Box
              display={"flex"}
              bg={theme.disable100}
              w={"35px"}
              h={"35px"}
              borderRadius={"full"}
              justifyContent={"center"}
              alignItems={"center"}
              flexShrink={0}
            >
              <BiUser fontSize="20px" />
            </Box>

            {/* Informações do Usuário */}
            <Flex
              flexDir={"column"}
              justifyContent={"center"}
              flex={1}
              minW={0}
              gap={1}
            >
              <Text
                fontSize={"11px"}
                color={"white"}
                noOfLines={1}
                title={capitalize(user)}
              >
                {truncateName(capitalize(user), 28)}
              </Text>
              <Text
                fontSize={"10px"}
                color={"whiteAlpha.800"}
                noOfLines={1}
                title={email}
              >
                {truncateName(email, 28)}
              </Text>
            </Flex>

            {/* Ícone de Opções */}
            <Flex
              alignItems={"center"}
              justifyContent={"center"}
              w={"fit-content"}
              flexShrink={0}
            >
              <Icon fontSize="16px" color={"whiteAlpha.700"}>
                <SlOptionsVertical />
              </Icon>
            </Flex>
          </Flex>

          {/* Menu de Opções */}
          <Flex
            flexDir={"column"}
            flex={1}
            p={{ base: 2, md: 3 }}
            gap={{ base: 1, md: 2 }}
            overflowY="auto"
            css={{
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-track": {
                background: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "whiteAlpha.300",
                borderRadius: "2px",
              },
            }}
          >
            {linkSidebar
              .filter(({ label }) => {
                if (label === "Bolsão de oportunidades") {
                  const atividade: string =
                    localStorage.getItem("@atividade") ?? "";
                  return (
                    tipoDeUsuario === "Corretor" &&
                    !atividade?.toLowerCase()?.includes("imob")
                  );
                }
                return true;
              })
              .map(({ icon, iconSelected, label, to }) => (
                <Box
                  key={label}
                  w={"100%"}
                  cursor={"pointer"}
                  onClick={() => {
                    handleNavigateMenu(label, to);
                  }}
                >
                  <Flex
                    w={"100%"}
                    minH={{ base: "44px", md: "48px" }}
                    px={3}
                    py={{ base: 2, md: 3 }}
                    alignItems={"center"}
                    borderRadius={"8px"}
                    gap={{ base: 3, md: 4 }}
                    bg={
                      pageSidebar === label
                        ? theme.backgroundPrimary
                        : "transparent"
                    }
                    _hover={{
                      bg:
                        pageSidebar === label
                          ? theme.backgroundPrimary
                          : "whiteAlpha.100",
                      transform: "translateX(4px)",
                    }}
                    transition="all 0.2s"
                    position="relative"
                  >
                    <Icon
                      fontSize={{ base: "16px", md: "18px" }}
                      color={"white"}
                      flexShrink={0}
                    >
                      {pageSidebar === label ? iconSelected : icon}
                    </Icon>

                    <Text
                      color={"white"}
                      fontSize={
                        label === "Bolsão de oportunidades"
                          ? "12px"
                          : { base: "13px", md: "14px" }
                      }
                      fontWeight={pageSidebar === label ? "semibold" : "normal"}
                      w={label === "Elô" ? "fit-content" : undefined}
                      flex={label === "Elô" ? undefined : 1}
                    >
                      {label}
                    </Text>

                    {/* Badge NOVO para Assistente virtual */}
                    {label === "Elô" && (
                      <Text
                        bg="transparent"
                        color="#EF8D91"
                        fontSize="7px"
                        fontWeight="medium"
                        w={"fit-content"}
                      >
                        NOVO
                      </Text>
                    )}
                  </Flex>
                </Box>
              ))}
          </Flex>

          {/* Footer com Logos */}
          <Flex
            justifyContent={"space-between"}
            alignItems={"flex-end"}
            mt="auto"
            mb={15}
          >
            {/* Logo Direcional */}
            <Flex justifyContent={"center"} alignItems={"center"} minH="20px">
              <Image
                src={logoDirecional || "/placeholder.svg"}
                alt="Direcional"
                h={"12px"}
                w="auto"
                opacity={0.8}
              />
            </Flex>

            {/* Logo Riva */}
            <Flex justifyContent={"center"} alignItems={"center"} minH="20px">
              <Image
                src={logoRiva || "/placeholder.svg"}
                alt="Riva"
                h={"20px"}
                w="auto"
                opacity={0.8}
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default React.memo(MenuSideBar);
